import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
// alert()
// let filename = window.location.href;
// let index = filename.lastIndexOf("admin");
let suffix = location.pathname;
// console.log(filename);
// console.log(suffix);
// console.log(suffix == "/admin/"||suffix == "/admin");
if (suffix == "/admin/"||suffix == "/admin") {//管理端
  // const login3 = r => require.ensure([], () => r(require('@/page/smmsadmin/login3')), 'login3');
  var login2 = r =>require.ensure([], () => r(require('@/page/smmsadmin/login3')), 'login3');
  var login = r =>require.ensure([], () => r(require('@/page/smmsadmin/login3')), 'login3');
  // var login2 = r => require.ensure([], () => r(require('@/page/smmsadmin/login3')), 'login3');
  // var manage = r => require.ensure([], () => r(require('@/page/smmsadmin/manage')), 'manage');
  // var manage1 = r => require.ensure([], () => r(require('@/page/manage')), 'manage1');
}else{//用户端
  var login = r => require.ensure([], () => r(require('@/page/login')), 'login');
  var login2 = r => require.ensure([], () => r(require('@/page/login2')), 'login2');
}


var manage = r => require.ensure([], () => r(require('@/page/manage')), 'manage');

/**申请列表*/
const applicationManage = r => require.ensure([], () => r(require('@/page/applicationManage')), 'applicationManage');

/**业务系统*/
const businessManage = r => require.ensure([], () => r(require('@/page/businessManage')), 'businessManage');

/**业务系统菜单详情*/
const businessManageDetail = r => require.ensure([], () => r(require('@/page/businessManageDetail')), 'businessManageDetail');

/**多语言配置页面*/
const languageManage = r => require.ensure([], () => r(require('@/page/languageManage')), 'languageManage');

const test = r => require.ensure([], () => r(require('@/test/test')), 'test');


const loginOn = r => require.ensure([], () => r(require('@/components/loginOn')), 'loginOn');

const onAuth = r => require.ensure([], () => r(require('@/page/onAuth')), 'onAuth');

const roleManage = r => require.ensure([], () => r(require('@/page/roleManage')), 'roleManage');
const workflow = r => require.ensure([], () => r(require('@/page/Workflow')), 'workflow');


// 页面模板
const applicationTemplate = r => require.ensure([], () => r(require('@/page/application/applicationTemplate')), 'applicationTemplate');
// 页面模板配置详情
const masterDataConfigDetails = r => require.ensure([], () => r(require('@/page/application/masterDataConfigDetails')), 'masterDataConfigDetails');
// 页面模板配置预览
const masterDataConfigPreview = r => require.ensure([], () => r(require('@/page/application/masterDataConfigPreview')), 'masterDataConfigPreview');

// 我的申请页面
const myApply = r => require.ensure([], () => r(require('@/page/approval/myApply')), 'myApply');

// 创建申请
const createApply = r => require.ensure([], () => r(require('@/page/approval/createApply')), 'createApply');

// 我的申请页面
const myApply2 = r => require.ensure([], () => r(require('@/page/approval/myApply2')), 'myApply2');

// 新增我的申请
const myApplyAdd = r => require.ensure([], () => r(require('@/page/approval/myApplyAdd')), 'myApplyAdd');

// 申请查看
const myApplyEdit = r => require.ensure([], () => r(require('@/page/approval/myApplyEdit')), 'myApplyEdit');

// 申请编辑
const myApplyEditDetails = r => require.ensure([], () => r(require('@/page/approval/myApplyEditDetails')), 'myApplyEditDetails');

// 我的审批
const myApproval = r => require.ensure([], () => r(require('@/page/approval/myApproval')), 'myApproval');
// 历史审批单据
const historicaldocuments = r => require.ensure([], () => r(require('@/page/approval/historicaldocuments')), 'historicaldocuments');

// 我的审批
const myApprovalAdd = r => require.ensure([], () => r(require('@/page/approval/myApprovalAdd')), 'myApprovalAdd');

// 审批编辑
const myApprovalEdit = r => require.ensure([], () => r(require('@/page/approval/myApprovalEdit')), 'myApprovalEdit');

// 流程配置页面
const processConfig = r => require.ensure([], () => r(require('@/page/systemSettings/processConfig')), 'processConfig');

// 步骤配置页面
const processConfigDetails = r => require.ensure([], () => r(require('@/page/systemSettings/processConfigDetails')), 'processConfigDetails');

// 步骤预览
const processConfigPreview = r => require.ensure([], () => r(require('@/page/systemSettings/processConfigPreview')), 'processConfigPreview');

// 审计追踪
const auditTrail = r => require.ensure([], () => r(require('@/page/systemSettings/auditTrail')), 'auditTrail');

// 错误日志
const errorLog = r => require.ensure([], () => r(require('@/page/systemSettings/errorLog')), 'errorLog');
//demo
const demo = r => require.ensure([], () => r(require('@/page/demo/index')), 'demo');
//配置审批流
const approvalConfig = r => require.ensure([], () => r(require('@/page/systemSettings/approvalConfig')), 'approvalConfig');

//管理员系统
const systemManageDetail = r => require.ensure([], () => r(require('@/page/smmsadmin/superSystemManage/systemManageDetail')), 'systemManageDetail');
const roleMenuManage = r => require.ensure([], () => r(require('@/page/smmsadmin/superSystemManage/systemManageDetail')), 'roleMenuManage');
/**多语言配置页面*/
const languageManageAdmin = r => require.ensure([], () => r(require('@/page/smmsadmin/languageManage')), 'languageManage');
//单据中心
const documentView = r => require.ensure([], () => r(require('@/page/documentView/index')), 'documentView');
//公司管理
const userManage = r => require.ensure([], () => r(require('@/page/smmsadmin/userManage/index')), 'userManage');

const allocateUsers = r => require.ensure([], () => r(require('@/page/smmsadmin/userManage/allocateUsers')), 'allocateUsers');
const companyManage = r => require.ensure([], () => r(require('@/page/smmsadmin/companyManage/index')), 'companyManage');
const superSystemManage = r => require.ensure([], () => r(require('@/page/smmsadmin/superSystemManage/index')), 'superSystemManage');
const normalManage = r => require.ensure([], () => r(require('@/page/smmsadmin/normalManage/index')), 'normalManage');
const superSystemManage2 = r => require.ensure([], () => r(require('@/page/smmsadmin/superSystemManage/index')), 'superSystemManage2');
const category = r => require.ensure([], () => r(require('@/page/smmsadmin/category')), 'category');
const modelcompanyManage = r => require.ensure([], () => r(require('@/page/smmsadmin/modelcompanyManage/index')), 'fieldPool');
const fieldPoolAdmin = r => require.ensure([], () => r(require('@/page/smmsadmin/fieldPoolManage/index')), 'fieldPool');
const conpanygroup = r => require.ensure([], () => r(require('@/page/smmsadmin/conpanygroup/index')), 'conpanygroup');
const explanation = r => require.ensure([], () => r(require('@/page/smmsadmin/explanation/index')), 'explanation');
const explanationField = r => require.ensure([], () => r(require('@/page/smmsadmin/explanation/explanationField')), 'explanationField');
const dictionary = r => require.ensure([], () => r(require('@/page/smmsadmin/dictionary/index')), 'dictionary');
const dictionaryValue = r => require.ensure([], () => r(require('@/page/smmsadmin/dictionary/dictionaryValue')), 'dictionaryValue');
// 404
const err = r => require.ensure([], () => r(require('@/page/err')), 'err');
//MDN
const authorizationManage = r => require.ensure([], () => r(require('@/page/MDM/authorizationManage')), 'authorizationManage');
const ParametConfig = r => require.ensure([], () => r(require('@/page/MDM/configManage')), 'configManage');
const DataTables = r => require.ensure([], () => r(require('@/page/MDM/dataTables')), 'dataTables');
const QingLiuMail = r => require.ensure([], () => r(require('@/page/MDM/qingliuMail')), 'QingFlowUsers');
const authorizationManageClient = r => require.ensure([], () => r(require('@/page/MDM/authorizationManageClient')), 'authorizationManageClient');
const userConfig = r => require.ensure([], () => r(require('@/page/MDM/userConfig')), 'userConfig');
const wduserConfig = r => require.ensure([], () => r(require('@/page/MDM/wduserConfig')), 'wduserConfig');
const mdmuserConfig = r => require.ensure([], () => r(require('@/page/MDM/mdmuserConfig')), 'wduserConfig');
const searchPage = r => require.ensure([], () => r(require('@/page/MDM/searchPage')), 'searchPage');
const resetPassword = r => require.ensure([], () => r(require('@/page/MDM/resetPassword')), 'resetPassword');
//OndID
const OneIDQuery = r => require.ensure([], () => r(require('@/page/OneID/OneIDQuery')), 'OneIDQuery');
const OneIDError = r => require.ensure([], () => r(require('@/page/OneID/OneIDError')), 'OneIDError');
const Doctor = r => require.ensure([], () => r(require('@/page/OneID/Doctor')), 'Doctor');
const Practice = r => require.ensure([], () => r(require('@/page/OneID/Practice')), 'Practice');
const Supplier = r => require.ensure([], () => r(require('@/page/OneID/Supplier')), 'Supplier');
const EmployeeQuery = r => require.ensure([], () => r(require('@/page/OneID/EmployeeQuery')), 'EmployeeQuery');


//admin路由
// export const SMMSADMINROUTES = [{
//     path: '/',
//     name: '登陆',
//     component: login3
//   },
//   {
//     path: '/manageAdmin',
//     component: manageAdmin,
//     children: [
//     ]
//   }
// ];
//web路由
export const SMMSWEBROUTES = [{
    path: '/test',
    component: test
  }, {
    path: '/demo',
    component: demo
  },
  {//404
    path: '/err',
    component: err
  },
  {
    path: '/onAuth',
    component: onAuth
  },
  {
    path: '/',
    //  component: login,
    component: login2 // 认证中心
  },
  {
    path: '/loginOn',
    component: loginOn
  },
  {
    path: '/manage',
    component: manage,
    children: [
      //OneID
      {
        path: '/oneIDQuery',
        component: OneIDQuery,
        meta: ['OneID', 'OneIDQuery'],
      },
      {
        path: '/oneIDError',
        component: OneIDError,
        meta: ['OneID', 'errorHandle'],
      },
      {
        path: '/doctor',
        component: Doctor,
        meta: ['OneID', 'DoctorQuery'],
      },
      {
        path: '/Practice',
        component: Practice,
        meta: ['OneID', 'Practice'],
      },
      {
        path: '/supplier',
        component: Supplier,
        meta: ['OneID', 'SupplierQuery'],
      },
      {
        path: '/employeeQuery',
        component: EmployeeQuery,
        meta: ['OneID', 'EmployeeQuery'],
      },
      {
        path: '/applicationManage',
        component: applicationManage,
        meta: ['myApplication', 'applicationList'],
      }, {
        path: '/businessManage',
        component: businessManage,
        meta: ['systemSetting', 'systemManagement'],
      }, {
        path: '/businessManageDetail',
        component: businessManageDetail,
        meta: ['systemSetting', 'systemManagement'],
      },
      {
        path: '/languageManage',
        component: languageManage,
        meta: ['systemSetting', 'languageConfig'],
      },
      {
        path: '/roleManage',
        component: roleManage,
        meta: ['workflow', 'roleManage'],
      },
      {
        path: '/documentView',
        component: documentView,
        meta: ["approval",'documentView'],
      },
      {
        path: '/workflowList',
        component: workflow,
        meta: ['workflow', 'workflowList'],
      },
      {
        path: "/applicationTemplate",
        component: applicationTemplate,
        meta: ["systemSetting", "pageTemplate"]
      },
      {
        path: "/masterDataConfigDetails",
        component: masterDataConfigDetails,
        meta: [
          "systemSetting",
          "pageTemplate",
          "masterDataDetails"
        ]
      },
      {
        path: "/masterDataConfigPreview",
        component: masterDataConfigPreview,
        meta: [
          "systemSetting",
          "pageTemplate",
          "preview"
        ]
      },
      // 我的申请
      {
        path: "/myApply",
        component: myApply,
        meta: ["approval", "myApplication"]
      },
      {
        path: "/myApply2",
        component: myApply2,
        meta: ["myApplication", "myApplication"]
      },
      { //创建申请
        path: "/createApply",
        name: "/createApply",
        component: createApply,
        meta: ["approval", "createApply"]
      },
      { //新增我的申请
        path: "/myApplyAdd",
        component: myApplyAdd,
        meta: ["approval", "myApplication", "addApplication"]
      },
      { //新增我的申请
        path: "/myApprovalAdd",
        component: myApprovalAdd,
        meta: ["approval", "myApplication", "addApplication"]
      },
      { //申请查看
        path: "/myApplyEdit",
        component: myApplyEdit,
        meta: ["approval", "myApplication", "preview"]
      },
      { //申请编辑
        path: "/myApplyEditDetails",

        component: myApplyEditDetails,
        meta: ["approval", "myApplication", "edit"]
      },
      { //我的审批
        path: "/myApproval",
        component: myApproval,
        meta: ["approval", "myApproval"]
      }, { //历史审批
        path: "/historicaldocuments",
        component: historicaldocuments,
        meta: ["approval", "aprrovalHistory"]
      },
      { //审批编辑
        path: "/myApprovalEdit",
        component: myApprovalEdit,
        meta: ["approval", "myApproval", "myApprovalEdit"]
      },
      { //流程配置
        path: "/processConfig",
        name: "/processConfig",
        component: processConfig,
        meta: ["systemSetting", "processConfig"]
      },
      { //步骤配置
        path: "/processConfigDetails",
        component: processConfigDetails,
        meta: ["systemSetting", "processConfig", "StepConfig"]
      },
      { //步骤预览
        path: "/processConfigPreview",
        component: processConfigPreview,
        meta: ["systemSetting", "processConfig", "stepPreview"]
      },
      { //配置审批流
        path: "/approvalConfig",
        component: approvalConfig,
        meta: ["systemSetting","processConfig","MasterMaintenance"]
      },
      { //审计追踪
        path: "/auditTrail",
        component: auditTrail,
        meta: ["systemSetting", "auditTrail"]
      },
      { //错误日志
        path: "/errorLog",
        component: errorLog,
        meta: ["systemSetting", "errorLog"]
           },{
        path: '/systemManageDetail',
        component: systemManageDetail,
        meta: ['systemManagement', 'businessManageDetail'],
      },{
        path: '/roleMenuManage',
        component: roleMenuManage,
        meta: ['roleMenuManage'],
      },
      {
        path: '/languageManageAdmin',
        component: languageManageAdmin,
        meta: ['systemManagement', 'languageManage'],
      },
      {
        path: '/companyManage/:id',
        component: companyManage,
        meta: ['systemManagement', 'companyConfiguration'],
      }, {
        path: '/superSystemManage/:id',
        component: superSystemManage,
        meta: ['systemManagement', 'businessSystem'],
      }, {
        path: '/superSystemManage2/:id',
        component: superSystemManage,
        meta: ['systemManagement', 'businessSystem'],
      }, {
        path: '/normalManage',
        component: normalManage,
        meta: ['companyInfo'],
      },
      {
        path: '/dictionary',
        component: dictionary,
        meta: ['systemManagement', 'dictionary'],
      },
      {
        path: '/userManage',
        component: allocateUsers,
        meta: ['userManage'],
      },
      {
        path: '/fieldPoolAdmin',
        component: fieldPoolAdmin,
        meta: ['systemManagement', 'fieldPool'],
      }, {
        path: '/modelcompanyManage',
        component: modelcompanyManage,
        meta: ['systemManagement', 'modelcompanyManage'],
      }, {
        path: '/conpanygroup',
        component: conpanygroup,
        meta: ['systemManagement', 'conpanygroup'],
      }, {
        path: '/explanation',
        component: explanation,
        meta: ['systemManagement', 'explanation'],
      }, {
        path: '/explanationField',
        component: explanationField,
        meta: ['systemManagement', 'explanationField'],
      },
      {
        path: "/category",
        name: "/category",
        component: category,
        meta: ["systemManagement", "category"]
      },
      {
        path: "/dictionaryValue",
        component: dictionaryValue,
        meta: ["systemManagement", "dictionaryValue"]
      },
      {
        path: '/authorizationManage',
        name: '/authorizationManage',
        component: authorizationManage,
        meta: ['applicationLog', 'authorizationManage'],
      },
      {
        path: '/authorizationManageClient',
        name: '/authorizationManageClient',
        component: authorizationManageClient,
        meta: ['applicationLog', 'authorizationManage', 'managementClient'],
      },
      {
        path: '/ParametConfig',
        name: '/ParametConfig',
        component: ParametConfig,
        meta: ['ParametConfig'],
      },
      {
        path: '/DataTables',
        name: '/DataTables',
        component: DataTables,
        meta: ['DataTables'],
      },
      {
        path: '/QingFlowUsers',
        name: '/QingFlowUsers',
        component: QingLiuMail,
        meta: ['QingFlowUsers'],
      },
      {
        path: '/userConfig',
        name: '/userConfig',
        component: userConfig,
        meta: ['userconfig'],
      },
      {
        path: '/wduserConfig',
        name: '/wduserConfig',
        component: wduserConfig,
        meta: ['wduserConfig'],
      },
      {
        path: '/mdmuserConfig',
        name: '/mdmuserConfig',
        component: mdmuserConfig,
        meta: ['wduserConfig'],
      },
      
      {
        path: '/searchPage',
        name: '/searchPage',
        component: searchPage,
        meta: ['keywordQuery'],
      },
      {
        path: '/resetPassword',
        name: '/resetPassword',
        component: resetPassword,
        meta: ['resetPassword'],
      },

    ]
  }
];

let createRouter = () => new Router({
  routes: SMMSWEBROUTES
})
const router = createRouter()

export default router



// WEBPACK FOOTER //
// ./src/router/index.js